<script setup>
import { ref, defineAsyncComponent } from 'vue'
// import { useAuthStore } from '@/store/auth'

const saldohutang = defineAsyncComponent(() =>
  import('@/components/laporan/hutang/SaldoHutang.vue')
)

const saldohutangjatuhtempo = defineAsyncComponent(() =>
  import('@/components/laporan/hutang/SaldoHutangJatuhTempo.vue')
)

// const auth = useAuthStore()

let laporan = ref('saldohutang')
let hideSideBar = ref(false)

const items = ref([
  {
    label: 'Laporan Saldo Hutang',
    icon: 'pi pi-arrow-circle-right',
    command: () => {
      laporan.value = 'saldohutang'
    },
    visible: true, //auth.user.roles.some((a) => ['admin', 'manager', 'edp', 'sp_penagihan', 'fakturis_pembelian', 'pembelian'].includes(a)),
  },  
  {
    label: 'Laporan Saldo Hutang Belum Jatuh Tempo',
    icon: 'pi pi-arrow-circle-right',
    command: () => {
      laporan.value = 'saldohutangjatuhtempo'
    },
    visible: true, //auth.user.roles.some((a) => ['admin', 'manager', 'edp', 'sp_penagihan', 'fakturis_pembelian', 'pembelian'].includes(a)),
  },  
])

function onToggle() {
  hideSideBar.value = !hideSideBar.value
}
</script>

<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">Laporan Hutang Usaha</span>
      <div>
        <i class="pi pi-home mr-2"></i>
        <span class="font-small">/ Laporan / Hutang Usaha</span>
      </div>
    </div>
    <div class="grid">
      <div
        class="col-12 md:col-3"
        :class="{
          hidden: hideSideBar,
          'transition-duration-500': hideSideBar,
        }"
      >
        <Menu :model="items" class="menu-laporan w-full border-none" />
      </div>
      <div
        class="card col-12 md:col-9"
        :class="{
          'md:col-12': hideSideBar,
          'transition-duration-200': hideSideBar,
        }"
      >
        <div>
          <saldohutang
            v-if="laporan === 'saldohutang'"
            @toggle="onToggle"
          />          
          <saldohutangjatuhtempo
            v-if="laporan === 'saldohutangjatuhtempo'"
            @toggle="onToggle"
          />          
        </div>
      </div>
    </div>
  </div>
</template>
